angular.module('dpw.services').factory('clipboardService', ['$q', function ($q) {
    return {
        copyTextToClipboard: copyTextToClipboard
    };

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            return fallbackCopyTextToClipboard(text);
        }
        return navigator.clipboard.writeText(text).then(function () {
            return true;
        }).catch(function () {
            return false;
        });
    }

    function fallbackCopyTextToClipboard(text) {
        return $q(function (resolve) {
            var textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            var successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            resolve(successful);
        });
    }
}]);
